import { render, staticRenderFns } from "./ListingPresentations.vue?vue&type=template&id=48a9f0a2"
import script from "./ListingPresentations.vue?vue&type=script&lang=js"
export * from "./ListingPresentations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports